import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import rawBankTransactionsApi from '@/features/dashboard/rawBankTransactions/api/rawBankTransactionsApi.ts';
import { getDeleteTransactionsErrorMessage } from '@/features/dashboard/rawBankTransactions/api/rawBankTransactionErrors.ts';
import { invalidateFinanceRelatedQueries } from '@/utils/invalidateFinanceQueries.ts';
import { pluralize } from '@/utils/pluralize.ts';

/**
 * Kasuje wiersze wyciągu — jeden albo paczkę. Backend przyjmuje tylko `PENDING`
 * i `IGNORED`; wpięty przelew odrzuca całą paczkę (nic nie znika), więc licznik
 * z odpowiedzi jest wiarygodny.
 *
 * Zaznaczenie po akcji zbiorczej czyści pasek zaznaczenia (`TableSelectionBar`),
 * bo tylko on siedzi w sklepie tabeli.
 */
const useDeleteRawTransactions = () => {
  const queryClient = useQueryClient();

  return useMutation<number, Error, string[]>({
    mutationFn: async (ids) => {
      if (ids.length === 1) {
        await rawBankTransactionsApi.delete(ids[0]);
        return 1;
      }
      const result = await rawBankTransactionsApi.deleteMany(ids);
      return result.deletedCount;
    },
    onSuccess: (deletedCount) => {
      toast.success(
        `Usunięto ${pluralize(deletedCount, 'przelew', 'przelewy', 'przelewów')}`,
      );
      invalidateFinanceRelatedQueries(queryClient);
    },
    onError: (error) => {
      toast.error('Nie udało się usunąć przelewów', {
        description: getDeleteTransactionsErrorMessage(error) ?? error.message,
      });
    },
  });
};

export default useDeleteRawTransactions;
